// เมื่อติดตั้งเป็น PWA จะไม่มีแถบของ Safari ให้เห็นว่าเน็ตหลุด — ต้องบอกเอง
// (service worker คืนข้อมูลที่แคชไว้ให้ หน้าจอจึงยังมีของแสดง แต่เป็นของเก่า)
import { useEffect, useState } from "react";
import { cn } from "@shared/lib/utils";

export function OfflineBar() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const sync = () => setOffline(!navigator.onLine);
    addEventListener("online", sync);
    addEventListener("offline", sync);
    sync();
    return () => {
      removeEventListener("online", sync);
      removeEventListener("offline", sync);
    };
  }, []);

  return (
    <div id="offline-bar" className={cn("offline-bar", offline && "show")}>
      ออฟไลน์ — ข้อมูลที่แสดงเป็นชุดล่าสุดที่โหลดไว้
    </div>
  );
}
